export function normalizeSubmitMentions(mentions) {
    return mentions.length > 0 ? mentions : undefined;
}
/**
 * Builds the tab mentions sent with an Ask submission from the tabs currently
 * attached by the user.
 *
 * Non-tab mentions are preserved, tab mentions for removed attachments are
 * dropped, and the active tab uses its latest URL in case the user navigated
 * after attaching it. Returns undefined when no mentions remain.
 */
export function replaceSubmitTabMentions({ activeTab, attachedTabs, mentions = [], }) {
    const nonTabMentions = mentions.filter((mention) => mention.type !== 'tab');
    const tabMentions = attachedTabs.map((tab) => ({
        type: 'tab',
        id: tab.id,
        url: String(activeTab.tabId) === tab.id ? activeTab.url : tab.url,
    }));
    return normalizeSubmitMentions([...nonTabMentions, ...tabMentions]);
}
//# sourceMappingURL=normalizeSubmitMentions.js.map